export default {
  anonymousUser: {
    id: 'reviews_anonymous_customer',
    defaultMessage: 'An anonymous Backer',
  },
  verified: {
    id: 'product_review_display_verified',
    defaultMessage: 'Verified',
  },
  verifiedPurchase: {
    id: 'product_review_display_verified_purchase',
    defaultMessage: 'Verified purchase',
  },
  reviewInfo: {
    id: 'product_review_display_review_info',
    defaultMessage: 'Reviewed {reviewDate}, {country}',
  },
  helpRequestInProgress: {
    id: 'product_review_display_help_request_in_progress',
    defaultMessage: 'Customer Care is working on this',
  },
  helpRequestResolved: {
    id: 'product_review_display_help_request_resolved',
    defaultMessage: 'Issue resolved by Customer Care',
  },
} as const
